document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.querySelector('.snow-announcement-bar .heart-container-wrapper');
  if (!wrapper) return;

  const maxHearts = 50;

  function createHeart() {
    const heart = document.createElement('div');
    heart.className = 'heart-container';
    heart.textContent = '🤍'; // white heart

    // Random horizontal start
    const startX = Math.random() * 100; // in %
    heart.style.left = startX + '%';

    // Random font size
    heart.style.fontSize = Math.random() * 12 + 5 + 'px';

    // Random fall duration
    const fallDuration = Math.random() * 2 + 2; // 2-4s
    heart.style.animationDuration = fallDuration + 's';

    // Random horizontal drift (-50px to +50px)
    const drift = Math.random() * 100 - 50 + 'px';
    heart.style.setProperty('--drift', drift);

    wrapper.appendChild(heart);

    // Remove heart after animation ends
    setTimeout(() => {
      heart.remove();
    }, fallDuration * 1000);
  }

  setInterval(() => {
    if (wrapper.children.length < maxHearts) {
      createHeart();
    }
  }, 200);
});